import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Button } from "react-bootstrap";

function WelcomeScreen() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/dashboard"); // Change to your desired route
  };

  return (
    <Container className="d-flex flex-column justify-content-center align-items-center vh-100 text-center">
      <h1 className="display-4 fw-bold">Welcome to Our Platform</h1>
      <p className="lead text-muted">A place where you can manage everything with ease.</p>
      {/* <Button variant="primary" size="lg" onClick={handleGetStarted} className="mt-3">
        Get Started
      </Button> */}
    </Container>
  );
}

export default WelcomeScreen;
